import { CloseButton, Heading, Flex, Button, useToast } from "@chakra-ui/react";
import Modal from "../overlay/Modal";
import SelectComponent from "../UI/Select";
import TextareaComponent from "../UI/Textarea";
import { archiveEmployee } from "../../util/http";
import { useState } from "react";

export default function TerminateEmployee({ show, name, id }) {
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState("");
  const [comment, setComment] = useState("");
  const toast = useToast();

  async function archiveHandler() {
    console.log(id);
    const data = {
      reason,
      comment,
    };
    if (!reason) {
      toast({
        title: `Select reason for suspension`,
        description: ``,
        status: "warning",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
      return;
    }
    try {
      setLoading(true);
      await archiveEmployee(id, data);
      setLoading(false);
      closeModal();
      window.location.reload();
      toast({
        title: `Successfully archived ${name}`,
        description: ``,
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    } catch (error) {
      setLoading(false);
      toast({
        title: `Error`,
        description: `${
          error?.response?.data.message || "something went wrong"
        }`,
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    }
  }

  function closeModal() {
    show(false);
  }
  return (
    <Modal>
      <Flex w="100%" align="start" direction="column" gap="1rem" py="1rem">
        <Flex w="100%" align="center" justify="space-between">
          <Heading
            size="md"
            color="var(--container_color)"
            fontWeight="bold"
            textTransform="capitalize"
          >
            Terminate {name}
          </Heading>
          <CloseButton onClick={closeModal} colorScheme="red" />
        </Flex>
        <SelectComponent
          onChange={(e) => setReason(e.value)}
          label="Select Reason"
          options={["Resignation", "Termination", "Retirement"]}
        />
        <TextareaComponent
          onChange={(e) => setComment(e.target.value)}
          value={comment}
          label="Add comment"
        />
        <Button
          isLoading={loading}
          loadingText="Submitting"
          onClick={archiveHandler}
          bg="brand.900"
          color="#fff"
          size="md"
          w="100%"
        >
          Terminate
        </Button>
      </Flex>
    </Modal>
  );
}
